import styled from '@emotion/styled'
import { ContentImagesDto } from '@pharmac-extranet/management-api'
import { useCallback, useMemo } from 'react'
import { useBreakpoint } from '../../hooks/useBreakpoints'

type PageHeaderImageProps = {
  image: ContentImagesDto
  rectangle?: boolean
}

const PageHeaderImageRoot = styled.div`
  width: 100%;
`
const PageHeaderImageImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`

export const PageHeaderImage = ({ image, rectangle }: PageHeaderImageProps) => {
  const breakpoint = useBreakpoint()

  const getImageUrl = useCallback(() => {
    if (breakpoint.minLarge && image.desktopLarge) return image.desktopLarge
    if (breakpoint.minDesktop && image.desktop) return image.desktop
    return image.mobile
  }, [image, breakpoint])

  const aspectRatio = useMemo(() => {
    if (breakpoint.maxMobile) return '5 / 4'
    return '16 / 9'
  }, [breakpoint])

  return (
    <PageHeaderImageRoot style={{ aspectRatio }}>
      <PageHeaderImageImage
        style={{ borderRadius: !!rectangle ? '0px' : 'var(--border-radius-tiny)' }}
        src={getImageUrl()}
      />
    </PageHeaderImageRoot>
  )
}
